/**
 * Utilitário de formatação de preços da assinatura Bookster.
 *
 * Os valores em si (renovação, original, promocional) vêm do backend
 * via campo `precoRenovacao` no payload do /api/v1/home/bookster.
 */

export function formatBRL( valor ) {
  if ( typeof valor !== 'number' ) {
    return ''
  }
  return `R$ ${valor.toFixed( 2 ).replace( '.', ',' )}`
}

export function formatBRLParcela( valor, parcelas ) {
  if ( typeof valor !== 'number' || typeof parcelas !== 'number' || parcelas < 1 ) {
    return ''
  }
  return formatBRL( valor / parcelas )
}
